<template>
    <content-loader
        :height="400"
        :width="390"
        :speed="0.5"
        primary-color="#f3f3f3"
        secondary-color="#ecebeb"
    >
        <rect x="40" y="20" rx="0" ry="0" width="310" height="140" />
        <rect x="40" y="200" rx="0" ry="0" width="310" height="20" />
        <rect x="40" y="240" rx="0" ry="0" width="310" height="20" />
        <rect x="40" y="280" rx="0" ry="0" width="310" height="20" />
    </content-loader>
</template>
<script>
import { ContentLoader } from "vue-content-loader";
export default {
    name: "VehicleDetailsLoader",
    components: { ContentLoader }
};
</script>
